import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { Box, Divider, Stack } from "@mui/material";
import dayjs from "dayjs";
import { QRCodeSVG } from "qrcode.react";
import React, { useState } from "react";

import { CopyButton } from "new-components/buttons/CopyButton";
import { GroundlightButton } from "new-components/buttons/GroundlightButton";
import { Typography } from "new-components/typography/Typography";

interface CreatedTokenDisplay {
  name: string;
  raw_key: string;
  expires_at: string | null;
}

interface CreatedTokenProps {
  apiToken: CreatedTokenDisplay;
  defautlShowQR: boolean;
  onClose: () => void;
}

export function CreatedToken(props: CreatedTokenProps) {
  const { defautlShowQR, apiToken, onClose } = props;

  const [isQRShown, setIsQRShown] = useState<boolean>(defautlShowQR);

  const toggleIsQRShown = () => {
    setIsQRShown((prev) => !prev);
  };

  return (
    <Stack className="w-full gap-2.5 sm:gap-4.5 px-[20px] py-[15px] items-center">
      <Typography variant="subtitle" align="center" className="text-primary-darker sm:text-[#15121A]">
        Token: <span className="font-bold sm:font-semibold">{apiToken.name}</span>
      </Typography>
      {apiToken.expires_at && (
        <Typography variant="subtitle" align="center" className="text-primary-darker sm:text-[#15121A]">
          Expires:{" "}
          <span className="font-bold sm:font-semibold">
            {dayjs(apiToken.expires_at).format("YYYY-MM-DD HH:mm:ss")}
          </span>
        </Typography>
      )}
      <Divider />
      <Box className="flex items-center">
        <Typography className="tracking-tight break-words">{apiToken.raw_key}</Typography>
        <CopyButton valueToCopy={apiToken.raw_key} />
      </Box>
      <Typography fontWeight="bold" align="center" className="text-primary-darker">
        Save it in a secure location - you will not be able to retrieve it at a later time!
      </Typography>
      <Divider />
      {isQRShown && (
        <Box className="flex justify-center w-full">
          <Box className="hidden sm:block">
            <QRCodeSVG value={apiToken.raw_key} size={166} data-testid="qrcode" />
          </Box>
          <Box className="sm:hidden">
            <QRCodeSVG value={apiToken.raw_key} size={264} data-testid="qrcode" />
          </Box>
        </Box>
      )}
      <Box onClick={toggleIsQRShown} className="flex gap-2.5 items-center cursor-pointer">
        <QrCodeScannerIcon className="text-[#49494D]" />
        <Typography className="tracking-tight">
          QR Token: Some applications allow Groundlight API tokens to be scanned as QR codes
        </Typography>
      </Box>
      <Divider />
      <GroundlightButton
        onClick={onClose}
        variant="plain"
        sx={{
          width: "200px",
        }}
      >
        Close
      </GroundlightButton>
    </Stack>
  );
}
